import React from "react";

const ServiceWhiteSvg = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Frame">
        <g id="Group">
          <path
            id="Vector"
            d="M11.303 13.516L12.4213 14.6343C12.5526 14.7655 12.7038 14.8629 12.8627 14.9383L14.9619 12.8391C14.8865 12.6801 14.7891 12.529 14.6579 12.3977L13.5396 11.2794L12.794 12.0249L7.04227 6.29769L7.85509 5.48484L4.37574 3L2.99902 4.37672L5.48387 7.8561L6.29668 7.04325L12.0485 12.7704L11.303 13.516Z"
            fill="white"
          />
          <path
            id="Vector_2"
            d="M10.1631 16.0727L11.303 15.007L9.81191 13.516L10.5575 12.7705L9.81191 12.0249L7.92652 13.8362C6.59634 13.3629 5.09067 13.6897 4.078 14.7025C2.63937 16.1411 2.63937 18.4825 4.078 19.9212C5.51666 21.3597 7.85814 21.3597 9.29666 19.9212C10.3093 18.9084 10.6363 17.4027 10.1631 16.0727ZM5.56901 18.4301C4.95237 17.8133 4.95237 16.8101 5.56901 16.1934C6.18561 15.5768 7.18894 15.5768 7.80554 16.1934C8.42229 16.8101 8.42229 17.8133 7.80554 18.4301C7.1889 19.0467 6.18575 19.0467 5.56901 18.4301Z"
            fill="white"
          />
          <path
            id="Vector_3"
            d="M7.05991 16.939C6.85417 16.7334 6.52005 16.7334 6.31435 16.939C6.10876 17.1447 6.10876 17.4788 6.31435 17.6845C6.52005 17.8903 6.85417 17.8903 7.05991 17.6845C7.26547 17.4788 7.26547 17.1447 7.05991 16.939ZM20.2219 16.5016L16.5215 12.7705L15.0303 14.2615L18.3581 17.6199L17.6125 18.3655L14.2849 15.0071L12.7938 16.498L16.4942 20.2293C17.5219 21.2569 19.1942 21.2569 20.2219 20.2293C21.2495 19.2016 21.2495 17.5293 20.2219 16.5016ZM13.8283 7.93395L12.0482 9.78843L12.7938 10.534L13.5393 9.78843L15.0303 11.2794L16.0648 10.1706C17.395 10.6439 18.9007 10.3169 19.9133 9.30419C21.0159 8.20159 21.3057 6.51395 20.6342 5.10482L20.5537 4.93618L18.4224 7.0677H16.9312V5.57651L19.0627 3.44521L18.8941 3.36487C17.4849 2.69321 15.7973 2.98297 14.6947 4.08558C13.6821 5.09825 13.3551 6.60392 13.8283 7.93395Z"
            fill="white"
          />
        </g>
      </g>
    </svg>
  );
};

export default ServiceWhiteSvg;
